/**
 * @description: 以module的形式导出./api/目录下所有js文件
 * @parameter {*}
 * @author: Mingzhen
 * @return {Object}
 */
const apiFiles = require.context('./api/', true, /.js$/)
export default apiFiles.keys().reduce((api, modulePath) => {
    const moduleName = modulePath.replace(/^.\/(.*)\.js/, '$1')
    const value = apiFiles(modulePath)
    api[moduleName] = value
    return api
}, {})
